"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnServAm = void 0;
const base_1 = require("./base");
/**
 * Mixpanel
 */
class AnServAm extends base_1.AnServBase {
    static isLoaded() {
        return ((window.amplitude !== undefined) &&
            (window.amplitude.getInstance !== undefined) &&
            (window.amplitude.getInstance().init !== undefined));
    }
    static sendInit(pixelId, userId, email, coupon) {
        const initProps = {
            includeUtm: true,
            includeReferrer: true,
        };
        amplitude.getInstance().init(pixelId, undefined, initProps);
        this.logEvent({
            cmd: "init",
            pixelId: pixelId,
            initProps: initProps
        });
        if (coupon !== null) {
            amplitude.getInstance().setUserProperties({ initial_coupon: coupon });
            this.logEvent({
                cmd: "setUserProperties",
                initial_coupon: coupon,
            });
        }
        return true;
    }
    static sendIdentify(pixelId, userId, email) {
        amplitude.getInstance().setUserId(userId.toString());
        this.logEvent({
            cmd: "setUserId",
            userId: email
        });
        return true;
    }
    static sendCustEvent(pixelId, eventName, eventProps) {
        amplitude.getInstance().logEvent(eventName, eventProps);
        this.logEvent({
            cmd: "logEvent",
            eventName: eventName,
            eventProps: eventProps
        });
        return true;
    }
    static sendCustEventCb(pixelId, eventName, eventProps, cb) {
        amplitude.getInstance().logEvent(eventName, eventProps, cb);
        this.logEvent({
            cmd: "logEvent",
            eventName: eventName,
            eventProps: eventProps,
            callback: true
        });
        return true;
    }
}
exports.AnServAm = AnServAm;
AnServAm.serviceName = "Amplitude";
